import { FunctionComponent, useState } from "react";
import TransitionWrapper from "../../components/transition-wrapper/TransitionWrapper";
import { PostTransferScreenProps } from "./typings";
import { LottieAnimation } from "@manifesthhqinc/ui-library";
import { HenryLoadingContainer, HenryLottieContainer } from "../henry-questionniare/screens/styles";
import Spacing from "../../layout/spacing";
import { BodyLargeRegular, HeadlineMedium } from "../../components/font";
import { ProgressBarContainer, TransferCheckAnimationContainer, TransferCheckContent } from "./styles";

const TransferCheck: FunctionComponent<PostTransferScreenProps> = ({ onNext = () => {}, phoneCallNeeded = true }) => {
  const [step, setStep] = useState<number>(0);
  const [showAssignSpecialist, setShowAssignSpecialist] = useState<boolean>(false);
  const showNextAnimation = () => {
    if (step === 3 && phoneCallNeeded) {
      setShowAssignSpecialist(true);
    } else if (step === 3) {
      onNext();
    } else {
      setStep(step + 1);
    }
  };
  if (showAssignSpecialist) {
    return (
      <TransitionWrapper>
        <HenryLoadingContainer $maxWidth="330px">
          <HenryLottieContainer>
            <LottieAnimation type="henry-loading" autoplay onComplete={onNext} height={200} width={200} />
          </HenryLottieContainer>
          <Spacing vertical="11" />
          <HeadlineMedium $textAlign="center">Assigning your specialist...</HeadlineMedium>
          <Spacing vertical="8" />
          <BodyLargeRegular $textAlign="center">
            Your account provider requires <br />a phone call.{" "}
          </BodyLargeRegular>
        </HenryLoadingContainer>
      </TransitionWrapper>
    );
  }
  if (step === 0) {
    return (
      <TransitionWrapper>
        <HenryLoadingContainer data-name="transfer-check-25checks">
          <HenryLottieContainer>
            <LottieAnimation type="henry-loading" autoplay onComplete={() => setStep(1)} height={200} width={200} />
          </HenryLottieContainer>
          <Spacing vertical="11" />
          <HeadlineMedium $textAlign="center">Just a moment...</HeadlineMedium>
          <Spacing vertical="8" />
          <BodyLargeRegular $textAlign="center">We’re running 25+ checks on your transfer details</BodyLargeRegular>
        </HenryLoadingContainer>
      </TransitionWrapper>
    );
  }

  return (
    <TransitionWrapper>
      <ProgressBarContainer>
        <LottieAnimation
          type={step === 1 ? "mobile-progress-1" : step === 2 ? "mobile-progress-2" : "mobile-progress-3"}
        />
      </ProgressBarContainer>
      <TransferCheckContent data-name="transfer-check-3steps-animation">
        <HeadlineMedium>
          {step === 1 ? "Reviewing accounts" : step === 2 ? "Scanning risks" : "Checking regulations"}
        </HeadlineMedium>
        <BodyLargeRegular>
          {step === 1
            ? "Verifying your traditional and Roth accounts and checking for loans or low balances."
            : step === 2
              ? "Detecting specialty investments or other risks that could slow down or complicate your transfer."
              : "Reviewing plan rules and checking if your provider needs a call to initiate your transfer."}
        </BodyLargeRegular>
      </TransferCheckContent>
      <TransferCheckAnimationContainer>
        <LottieAnimation
          type={step === 1 ? "review-account" : step === 2 ? "scanning-risks" : "checking-regulations"}
          autoplay
          onComplete={showNextAnimation}
          height={200}
          width={200}
        />
      </TransferCheckAnimationContainer>
    </TransitionWrapper>
  );
};

export default TransferCheck;
